<template>
  <Modal
    :id="'cmp-royalty-accounts-external-user-list-modal'"
    @cancelled="onCancel"
  >
    <template slot="header">User List </template>
    <template slot="body">
      <SearchList
        :id="'ext_users'"
        :items="items"
        :keyProperty="'external_users_permission_id'"
        :label="'user_name'"
        :placeholder="'Search'"
        :selectionNumber="'single'"
        :isSearchable="false"
        @selected="onContactItemClick"
      />
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import * as ActionTypes from "../../store/types";
import SearchList from "@dtplugins/search-list/search-list";
import InputField from "@plugins/text-field/input-field";
import TextField from "@plugins/text-field/text-field";
import Modal from "@dtplugins/modal/modal";
import { openWindow, sendMailHref } from "../../../../utility";
import { AccountsService } from "../../services/accounts.service";
export default {
  components: {
    InputField,
    TextField,
    Modal,
    SearchList,
  },
  props: ["selectedAccountDetails"],
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        statusInside: true,
      },
      validationResult: {},
      newData: {
        description: "",
        amount: "",
        external_id: 0,
      },
      externalUserList: [],
    };
  },
  mounted: function () {
    this.royaltyAccountExternalUserLinks();
  },
  watch: {},
  computed: {
    items: function () {
      return this.externalUserList || [];
    },
    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },
    isFormValid: function () {
      return this.newData.description;
    },
  },
  methods: {
    onCancel() {
      this.$emit("cancelled");
    },
    royaltyAccountExternalUserLinks() {
      AccountsService.royaltyAccountExternalUserLinks(
        this.royalty_account_id
      ).then((res) => {
        this.externalUserList = res.data.ext_users;
      });
    },

    onContactItemClick: function (releases) {
      const user_ids = Array.from(releases);
      if (user_ids && user_ids.length>0) {
        let user = this.externalUserList.find(
          (r) => r.external_users_permission_id === user_ids[0]
        );
        openWindow(user.b2b_link, "_blank", { wr: 0.7, hr: 0.7 });
        this.$emit("cancelled");
      }
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-accounts-external-user-list-modal {
  .dt-table2 {
    --body-height: 300px !important;
  }
}
</style>
